import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as state from '../../../../../../../state'

import { Store } from './store'
import * as workspaceTree from './workspace-tree'

@ngCore.Component({
  imports: [
    ds.loader.Component,
    ds.overlay.attached.Component,
    workspaceTree.Component,
  ],
  providers: [Store],
  selector: 'atn-conversation-selector',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.assistant.conversational.Group} */
  public readonly assistantGroup = ngCore.inject(
    state.assistant.conversational.Group,
  )

  /**
   * Controls the visibility of the add menu
   */
  public readonly addMenuOpenSg = ngCore.signal(false)

  /**
   * Create a new conversation for the current assistant
   */
  public createConversation(): void {
    this.addMenuOpenSg.set(false)
    this.assistantGroup.conversation.plugins.currentEntityPlugin.storage.actions.putInIdLookup
      .from('Dolomite.ChatPage.Conversation.Selection.Changed')
      .dispatch({
        value: undefined,
      })
  }

  /**
   * Create a new workspace for the current assistant
   */
  public createWorkspace(): void {
    this.addMenuOpenSg.set(false)
    this.assistantGroup.workspace.plugins.editingPlugin.feature.actions.edit
      .from('Dolomite.ChatPage.Workspace.Create.Clicked')
      .dispatch({
        id: ec.plugins.standard.editing.models.CreationId.generate(),
      })
  }
}
